module.exports = __webpack_public_path__ + "KlavikaLight.93db8208714bb655707b.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/fonts/klavika_font/KlavikaLight.ttf
// module id = ../../../../../src/assets/fonts/klavika_font/KlavikaLight.ttf
// module chunks = styles